import React, { Component, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ScriptableContext,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useUserStore } from '../../stores/userStore';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      display: false,
      grid: {
        display: false,
      }
    },
    y: {
      display: false,
      grid: {
        display: false,
      },
    }
  },
  plugins: {
    subtitle: {
      display: false
    },
    legend: {
      display: false
    },
    title: {
      display: false,
      // text: 'Chart.js Bar Chart',
    },
    tooltip: {
      enabled: true
    }

  },
};

const ChartMembers: React.FC = () => {
  const userStore = useUserStore();
  const [labels, setLabels] = React.useState(Array.from({ length: 12 }, (_, i) => moment().subtract(i, 'months').format('MMM')).reverse());
  const [data, setData] = React.useState<{ labels: string[], datasets: { label: string, data: number[], fill: boolean, borderColor: string, backgroundColor: string | ((context: ScriptableContext<"line">) => CanvasGradient), tension: number, borderWidth: number, pointRadius: number, pointHoverRadius: number }[] }>({ labels: [], datasets: [] });
  const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş

  useEffect(() => {
    const numberOfUsers = labels.map(label => userStore.users.filter(user => moment(user.createdAt).format('MMM') === label).length);

    const data = {
      labels,
      datasets: [
        {
          label: t('members'),
          data: numberOfUsers,
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: (context: ScriptableContext<"line">) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 220);
            gradient.addColorStop(0, "#14b498");
            gradient.addColorStop(1, "#17897900");
            return gradient;
          },
          tension: 0.1,
          fill: true,
          lineTension: 0.5,
          borderWidth: 2,
          pointHoverRadius: 4,
          pointRadius: 1,
        },
      ],
    };

    setData(data);
  }, [userStore.users]);

  return (
    <div className="card-block card-block-01">
      <div className="d-flex justify-content-between">
        <div className="block-left">
          <h2>{t('members')}</h2>
          <p>{t('last30Days')} - <code>{userStore.users.filter(user => moment(user.createdAt).isAfter(moment().subtract(30, 'days'))).length}</code></p>
          <a href="#" className="details-button" title={t('details')}><i className="ti-arrow-circle-right"></i> {t('details')}</a>
        </div>
        <div className="block-right">
          <Line options={options} data={data} />
        </div>
      </div>
    </div>
  );
};

export default ChartMembers;
